/* eslint-disable react/iframe-missing-sandbox */
/* eslint-disable max-len */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/jsx-child-element-spacing */
import { Stack } from '@mui/material'

import type { MarketingLink } from 'src/models/Marketing'
import type { BasicOrganisation } from 'src/models/Organisation'

type Props = {
  readonly link: MarketingLink | undefined
  readonly organisation: BasicOrganisation
  readonly event: string
  readonly platform: string
}

const SignUpForm = (props: Props) =>
  <Stack height={240} spacing={1} width={1}>
    {props.link &&
      <iframe
        sandbox='allow-scripts allow-forms allow-same-origin'
        src={
          process.env.NODE_ENV === 'production'
            ? `https://releese.rls.ee/embed-form/${props.link.id}/${props.organisation.id}/${props.event.replace(' ', '-')}/${props.platform}`
            : `http://localhost:3001/embed-form/${props.link.id}/${props.organisation.id}/${props.event.replace(' ', '-')}/${props.platform}`
        }
        style={{
          background: 'transparent',
          border: 'none',
          height: '100%',
          width: '100%',
        }}
        title='Sign up form'
      />}
  </Stack>

export default SignUpForm
